import React from "react";
import {
  ContentCard,
  LandingSection,
  SectionHeader,
} from "./landing/landing-ui";

const services = [
  {
    id: 1,
    title: "AI Agent Development",
    description:
      "Agents that read context, call tools and APIs, and complete multi-step work inside your operations.",
    url: "/ai-agent-development",
    outcome: "Fewer handoffs, faster cycle time",
  },
  {
    id: 2,
    title: "Custom LLM Applications",
    description:
      "Domain assistants, knowledge systems, and decision support built on retrieval, evaluation, and governance.",
    url: "/custom-llm-application-development",
    outcome: "Answers grounded in your data",
  },
  {
    id: 3,
    title: "AI MVP and PoC Development",
    description:
      "Focused pilots that prove value, data fit, and integration risk before you fund a full build.",
    url: "/mvp-poc-development",
    outcome: "Clear go or no-go evidence",
  },
  {
    id: 4,
    title: "AI Workflow Automation",
    description:
      "Document flows, approvals, and operational handoffs automated with models, rules, and human review.",
    url: "/ai-workflow-automation",
    outcome: "Less manual processing",
  },
  {
    id: 5,
    title: "AI Integrations",
    description:
      "Connect AI to ERP, CRM, and internal platforms without replacing the systems your teams already trust.",
    url: "/ai-integrations",
    outcome: "Works inside your stack",
  },
];

function WhatWeBuild() {
  return (
    <LandingSection>
      <SectionHeader
        title="What we build"
        lead="Production-grade AI for operations teams. We start from the workflow, not the model, and ship systems your people can use day to day."
      />

      <div className="mt-12 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {services.map((item, index) => (
          <ContentCard
            key={item.id}
            number={String(index + 1).padStart(2, "0")}
            title={item.title}
            description={`${item.description} ${item.outcome}.`}
            href={item.url}
            className={index === 0 ? "md:col-span-2 lg:col-span-1" : ""}
          />
        ))}
      </div>
    </LandingSection>
  );
}

export default WhatWeBuild;
